/**
 * 
 */
export interface GoodsInfo {
    id?: string,
    weight: number,
    name: string,
    count: number,
    packageType?: string,
    // 荷物の制約事項
    handlingInstructions?: string[];
    // 寸法
    dimensions?: Dimensions
}

export interface Dimensions {
    // 縦
    length: number,
    // 横
    width: number,
    // 高さ
    height: number
}

export function getTotalWeight(items: GoodsInfo[]): number {
    let result = 0;
    items.map((v, i) => result += (v.weight * v.count));
    return result;
}